module.exports = __webpack_public_path__ + "img/edit-file.bcea2b7f.svg";